module.exports = __webpack_public_path__ + "static/media/03_07_09.ad5c9167.png";